import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Luxurybusonrentinahmednagar() {



  const cardData =
  {
    keyword: 'Luxury Bus on Rent in Ahmednagar',
    heading: 'Sanavi Travels: Luxury Bus on Rent in Ahmednagar',
    headingDescription: 'Sanavi Travels offers Luxury Bus on Rent in Ahmednagar, providing premium, safe, and comfortable transportation for weddings, corporate events, group tours, school trips, picnics, and outstation journeys. Our fleet of well-maintained luxury AC buses and coaches is equipped with modern amenities, spacious seating, and ample luggage space to ensure a smooth and stylish travel experience. With professional drivers, flexible rental packages, transparent pricing, and 24/7 booking support, luxury bus rental services in Ahmednagar are ideal for stress-free, punctual, and reliable group travel across Ahmednagar, Pune, Mumbai, Shirdi, Mahabaleshwar, and other nearby destinations.',

    top: 'Top Places to Visit in Ahmednagar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ahmednagar City",
    "description": "Ahmednagar is a historic city in Maharashtra known for its rich cultural heritage, medieval forts, and spiritual significance. Located in the heart of the state, it played a prominent role during the Nizam Shahi and Maratha periods. The city is famous for its historical monuments, Sufi shrines, and rural charm, making it a mix of history, spirituality, and cultural tourism."
  },
  {
    "title": "Ahmednagar Fort",
    "description": "Ahmednagar Fort is a 15th-century structure built by Ahmad Nizam Shah I. It has served as a military stronghold, prison, and royal residence over the centuries. The fort houses several tombs, mosques, and temples inside its expansive walls. Its historical importance, architecture, and panoramic views make it a popular site for history enthusiasts and photographers."
  },
  {
    "title": "Shirdi Sai Baba Temple (Nearby)",
    "description": "Ahmednagar is located close to Shirdi, the spiritual center of Sai Baba devotees. Pilgrims traveling from Ahmednagar often visit the Sai Baba Temple, which is one of India’s most famous spiritual destinations, attracting millions of devotees annually."
  },
  {
    "title": "Grishneshwar Jyotirlinga (Near Ellora Caves)",
    "description": "Located within reach from Ahmednagar, Grishneshwar Temple is a Jyotirlinga dedicated to Lord Shiva. Its intricate carvings and sanctum attract pilgrims seeking spiritual blessings and a glimpse into ancient Indian architecture. The temple is often combined with visits to the nearby Ellora Caves."
  },
  {
    "title": "Siddheshwar Temple",
    "description": "Siddheshwar Temple is a significant Shiva shrine in Ahmednagar city. Devotees visit to perform rituals, celebrate festivals, and seek spiritual solace. The temple’s architecture and local legends make it an important part of the city’s religious fabric."
  },
  {
    "title": "Stepwells and Historical Water Structures",
    "description": "Ahmednagar houses several ancient stepwells and water reservoirs built during the medieval period. These structures reflect advanced engineering and architectural skills of the time, offering insights into the city’s urban planning and water management history."
  },
  {
    "title": "Cultural Festivals and Fairs",
    "description": "Ahmednagar celebrates various religious and cultural festivals such as Ganesh Chaturthi, Mahashivratri, and Urs with grandeur. Local fairs showcase folk music, dance, and crafts, providing visitors an immersive experience of regional traditions."
  },
  {
    "title": "Rural Villages and Agriculture",
    "description": "The countryside around Ahmednagar is fertile and predominantly agricultural, cultivating sugarcane, pulses, and vegetables. Exploring nearby villages provides insight into rural life, farming practices, and local cuisine."
  },
  {
    "title": "Sufi Shrines and Dargahs",
    "description": "Ahmednagar has several historic Sufi shrines and dargahs, reflecting the city’s spiritual diversity. These sites are centers of devotion, music, and community gatherings, offering visitors a unique cultural and spiritual experience."
  },
  {
    "title": "Natural Landscapes and Hills",
    "description": "Ahmednagar is surrounded by scenic hills, rivers, and forests. These natural landscapes provide opportunities for trekking, photography, and weekend getaways, especially during the monsoon when the region is lush and vibrant."
  }
]
,



"services": [
{
"name": "Luxury Bus on Rent in Ahmednagar",
"description": "Luxury Bus on Rent in Ahmednagar provides premium travel solutions for families, corporate groups, and tourists seeking comfort and elegance. Equipped with spacious seating, modern amenities, and professional drivers, it ensures a safe, smooth, and enjoyable journey. Ideal for weddings, long-distance travel, and group outings, this service combines style, reliability, and convenience for all passengers."
},
{
"name": "Luxury Bus Hire Ahmednagar",
"description": "Luxury Bus Hire Ahmednagar offers flexible rental options for groups, corporate events, and special occasions. With high-quality buses, skilled chauffeurs, and timely service, it guarantees a luxurious and hassle-free travel experience. Perfect for sightseeing trips, religious tours, family outings, and wedding transportation, ensuring comfort and sophistication throughout the journey."
},
{
"name": "AC Luxury Bus Ahmednagar",
"description": "AC Luxury Bus Ahmednagar ensures a cool and comfortable ride with air-conditioned interiors, plush seating, and professional drivers. Suitable for corporate tours, family trips, and tourist excursions, it provides a refreshing and relaxing travel experience even on long journeys, prioritizing passenger comfort and safety."
},
{
"name": "Wedding Luxury Bus Ahmednagar",
"description": "Wedding Luxury Bus Ahmednagar delivers elegant and spacious buses for transporting guests to and from wedding venues. Equipped with modern amenities and handled by experienced drivers, it ensures a comfortable, timely, and memorable journey for families and friends attending weddings in and around Ahmednagar."
},
{
"name": "Corporate Luxury Bus Ahmednagar",
"description": "Corporate Luxury Bus Ahmednagar provides organized and professional transport for employee commutes, business events, corporate tours, and team outings. Well-maintained buses, punctual service, and experienced chauffeurs ensure safe, efficient, and comfortable travel for corporate clients."
},
{
"name": "Outstation Luxury Bus Ahmednagar",
"description": "Outstation Luxury Bus Ahmednagar offers reliable long-distance travel solutions for families, corporate groups, and tourists. Spacious seating, modern amenities, and skilled drivers make intercity trips, religious tours, and leisure travel safe, comfortable, and enjoyable."
},
{
"name": "Affordable Luxury Bus Ahmednagar",
"description": "Affordable Luxury Bus Ahmednagar provides cost-effective yet premium travel options for families, groups, and corporate clients. With well-maintained buses, professional drivers, and budget-friendly rates, it ensures a luxurious travel experience without compromising on comfort or safety."
},
{
"name": "Chauffeur Driven Luxury Bus",
"description": "Chauffeur Driven Luxury Bus offers stress-free travel with professional drivers handling traffic, navigation, and schedules. Perfect for weddings, corporate trips, tourist excursions, and group travel, it guarantees a comfortable and hassle-free journey with complete focus on passenger convenience."
},
{
"name": "Best Luxury Bus Service Ahmednagar",
"description": "Best Luxury Bus Service Ahmednagar ensures high-quality buses, expert chauffeurs, and punctual service for all types of group travel. Ideal for weddings, corporate events, family outings, and tourist trips, it delivers a safe, comfortable, and memorable journey for every passenger."
},
{
"name": "Tourist Luxury Bus Ahmednagar",
"description": "Tourist Luxury Bus Ahmednagar caters to travelers exploring Ahmednagar and nearby attractions. Spacious and well-equipped buses, professional drivers, and flexible itineraries provide a comfortable, convenient, and enjoyable travel experience for tourists and groups."
},
{
"name": "Group Travel Luxury Bus",
"description": "Group Travel Luxury Bus is designed for large groups, friends, corporate teams, and families traveling together. Comfortable seating, modern amenities, and professional drivers ensure smooth, safe, and enjoyable journeys for all passengers."
},
{
"name": "Online Bus Booking Ahmednagar",
"description": "Online Bus Booking Ahmednagar allows travelers to conveniently reserve luxury buses with instant confirmation. Multiple vehicle options, flexible scheduling, and secure online payments simplify planning for weddings, corporate events, tours, and group travel."
},
{
"name": "Event Luxury Bus Ahmednagar",
"description": "Event Luxury Bus Ahmednagar provides dedicated transportation for weddings, corporate gatherings, social functions, and special occasions. Spacious seating, professional chauffeurs, and reliable service ensure organized, safe, and enjoyable travel for all attendees."
},
{
"name": "Ahmednagar Travel Bus",
"description": "Ahmednagar Travel Bus offers comprehensive transportation solutions for sightseeing, corporate events, weddings, and outstation trips. With well-maintained buses, skilled drivers, and high-quality service, it ensures safe, comfortable, and convenient travel for families, groups, and businesses."
},
{
"name": "Premium Bus Rental Ahmednagar",
"description": "Premium Bus Rental Ahmednagar delivers top-notch bus services for luxury travel, corporate trips, weddings, and leisure tours. Equipped with modern amenities, spacious interiors, and experienced chauffeurs, it guarantees a stylish, safe, and comfortable journey for all passengers seeking a premium travel experience."
}
],
"tableData": [
["Luxury Bus on Rent in Ahmednagar", "Luxury Bus Hire Ahmednagar"],
["AC Luxury Bus Ahmednagar", "Wedding Luxury Bus Ahmednagar"],
["Corporate Luxury Bus Ahmednagar", "Outstation Luxury Bus Ahmednagar"],
["Affordable Luxury Bus Ahmednagar", "Chauffeur Driven Luxury Bus"],
["Best Luxury Bus Service Ahmednagar", "Tourist Luxury Bus Ahmednagar"],
["Group Travel Luxury Bus", "Online Bus Booking Ahmednagar"],
["Event Luxury Bus Ahmednagar", "Ahmednagar Travel Bus"],
["Premium Bus Rental Ahmednagar", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Luxury Bus on Rent in Ahmednagar with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides premium luxury bus rental services in Ahmednagar, perfect for group travel, corporate events, family tours, pilgrimages, and special occasions with superior comfort and style."
  },
  {
    "WhyChooseheading": "Premium and Well‑Maintained Coaches",
    "WhyChoosedescription": "Our luxury buses are clean, air‑conditioned, and equipped with modern amenities like plush seating, entertainment systems, and ample legroom for an enjoyable journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are trained to deliver professional service and are familiar with routes from Ahmednagar to your chosen destinations."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for luxury bus rentals in Ahmednagar, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, travel queries, and itinerary changes for your luxury bus service."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, or customized luxury bus hire packages based on your group’s schedule and travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Each luxury bus is thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for luxury bus rentals in Ahmednagar."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide luxury bus rental services in Ahmednagar?',
    answer: 'Yes, Sanavi Travels offers premium luxury bus rental services in Ahmednagar for various travel needs.'
  },
  {
    question: 'How can I book a luxury bus in Ahmednagar?',
    answer: 'You can easily book a luxury bus through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What features are included in the luxury buses?',
    answer: 'Our luxury buses feature comfortable seating, air‑conditioning, entertainment systems, ample legroom, and modern amenities for a pleasant journey.'
  },
  {
    question: 'Are the drivers experienced with routes from Ahmednagar?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with routes from Ahmednagar to ensure safe and timely travel.'
  },
  {
    question: 'Can I choose custom pickup and drop‑off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop‑off locations in Ahmednagar or nearby areas.'
  },
  {
    question: 'Is the luxury bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round‑the‑clock luxury bus rental services in Ahmednagar to suit your travel schedule.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all luxury buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for luxury bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for luxury bus bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your luxury bus trip in Ahmednagar.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ramesh Patil',
    feedback: 'Booked a luxury bus in Ahmednagar with Sanavi Travels — the journey was extremely comfortable, and service was top‑notch!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Shruti Deshmukh',
    feedback: 'Sanavi Travels provided a premium luxury bus rental experience in Ahmednagar — spacious, clean, and very comfortable. Highly recommended!',
    rating: 5
  }
];





































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Luxury Bus on Rent in Ahmednagar - Sanavi Travels",
  "description": "Rent a luxury bus in Ahmednagar with Sanavi Travels. AC, chauffeur-driven buses available for weddings, corporate trips, outstation tours, group travel, events, and tourist trips. Affordable and premium options available with online booking.",
  "touristType": "Luxury Travel, Wedding, Corporate, Outstation, Group Travel, Tourist",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "22"
  }
};








  return (
    <div>
<Helmet>
  <title>
    Luxury Bus on Rent in Ahmednagar | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book a luxury bus in Ahmednagar with Sanavi Travels. AC and chauffeur-driven buses for weddings, corporate trips, outstation tours, group travel, and events. Affordable and premium buses available. Online booking open."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/163.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Luxurybusonrentinahmednagar;